<template>
  <Row>
    <i-col span="12">
      <div id="chart-container">
        <fusioncharts
          :type="type"
          :width="width"
          :height="height"
          :dataFormat="dataFormat"
          :dataSource="dataSource"
          @dataplotRollover="dataplotRollover"
          @dataLabelRollOver="dataplotRollover"
        ></fusioncharts>
        <div v-html="displayValue"></div>
      </div>
    </i-col>
    <i-col span="11" offset="1">
      <i-table
        :columns="tableColumns"
        :data="tableData"
        :row-class-name="rowClassName"
      ></i-table>
    </i-col>
  </Row>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import moment from "moment";
import VueFusionCharts from "vue-fusioncharts";
import FusionCharts from "fusioncharts";
import Column2D from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

Vue.use(VueFusionCharts, FusionCharts, Column2D, FusionTheme);

let defaultDataSource = {
  chart: {
    caption: "Number of facts created by Expert",
    subCaption: "",
    theme: "fusion",
  },
};

export default {
  props: {
    period: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      displayValue: "",
      type: "msbar2d",
      renderAt: "chart-container",
      width: "100%",
      height: "620",
      dataFormat: "json",
      dataSource: defaultDataSource,
      tableColumns: [
        {
          title: "Expert",
          key: "expert",
        },
        {
          title: "Previos Period",
          key: "previous",
        },
        {
          title: "Reference Period",
          key: "reference",
        },
        {
          title: "Variation",
          key: "variation",
        },
      ],
      tableData: [],
      highlight: -1,
    };
  },
  created() {
    this.load();
  },
  watch: {
    period() {
      this.load();
    },
  },
  methods: {
    async load() {
      const params = {
        _start: this.period[0],
        _end: this.period[1],
      };

      let response = await axios.post(
        "/psql/rpc/qa_dashboard_nfacts_user",
        params
      );
      // console.table(response.data);
      this.tableData = response.data;

      // New dataSource
      // -------------------------------------------------------------------
      const currentDataSource = Object.assign({}, this.dataSource);
      currentDataSource.categories = [];
      currentDataSource.dataset = [];

      // Change chart sub-caption
      const start_date = moment(this.period[0]).format("YYYY-MM-DD");
      const end_date = moment(this.period[1]).format("YYYY-MM-DD");
      currentDataSource.chart.subCaption = `Between ${start_date} and ${end_date}`;

      // extract categories
      // -------------------------------------------------------------------
      let category = [];
      for (const record of response.data) {
        category.push({ label: record.expert });
      }
      currentDataSource.categories.push({ category });

      // extract previous_period series
      // -------------------------------------------------------------------
      let previous_period = {
        seriesname: "Previous Period",
        data: [],
      };
      for (const record of response.data) {
        previous_period.data.push({ value: record.previous });
      }
      currentDataSource.dataset.push(previous_period);

      // extract reference_period series
      // -------------------------------------------------------------------
      let reference_period = {
        seriesname: "Reference Period",
        data: [],
      };
      for (const record of response.data) {
        reference_period.data.push({ value: record.reference });
      }
      currentDataSource.dataset.push(reference_period);

      // Update chart
      // -------------------------------------------------------------------
      this.dataSource = currentDataSource;
    },
    dataplotRollover(e) {
      this.highlight = e.data.index;
    },
    rowClassName(row, index) {
      if (index === this.highlight) {
        return "ivu-table-row-hover";
      }

      if (row.reference === null || row.previous === null) {
        return "demo-table-error-row";
      }
      return "";
    },
  },
};
</script>

<style>
.ivu-table .demo-table-info-row td {
  background-color: #2db7f5;
  color: #fff;
}
.ivu-table .demo-table-error-row td {
  background-color: #ff6600;
  color: #fff;
}
.ivu-table td.demo-table-info-column {
  background-color: #2db7f5;
  color: #fff;
}
.ivu-table .demo-table-info-cell-name {
  background-color: #2db7f5;
  color: #fff;
}
.ivu-table .demo-table-info-cell-age {
  background-color: #ff6600;
  color: #fff;
}
.ivu-table .demo-table-info-cell-address {
  background-color: #187;
  color: #fff;
}
</style>
